import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLoader from '@/ui-library/PageLoader';
import { useAuth } from './auth/AuthProvider';

export const Login = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/chat?guest=true', { replace: true });
    signIn();
  }, [signIn, navigate]);

  return <PageLoader />;
};
